module.exports = __webpack_public_path__ + "img/ecommerce-product-img-2.3c07f53a.png";